import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-d-flex as-flex-column as-box-match-info" }
const _hoisted_2 = { class: "as-item as-d-flex as-align-items-center" }
const _hoisted_3 = { class: "as-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "as-info" }
const _hoisted_6 = { class: "as-nation" }
const _hoisted_7 = { class: "as-item as-d-flex as-align-items-center" }
const _hoisted_8 = { class: "as-icon" }
const _hoisted_9 = { class: "as-info" }
const _hoisted_10 = { class: "as-nation" }
const _hoisted_11 = { class: "as-item as-d-flex as-align-items-center" }
const _hoisted_12 = { class: "as-icon" }
const _hoisted_13 = { class: "as-info" }
const _hoisted_14 = { class: "as-nation" }
const _hoisted_15 = { class: "as-item as-d-flex as-align-items-center" }
const _hoisted_16 = { class: "as-icon" }
const _hoisted_17 = { class: "as-info" }
const _hoisted_18 = { class: "as-nation" }

import { computed } from "vue";
import InformationIcon from "~src/components/matches/InformationIcon.vue";
import StatsEnum from "~src/enums/tennis/StatsEnum";
import IconTournamentCourt from "~src/components/icons/IconTournamentCourt.vue";
import IconTournamentTime from "~src/components/icons/IconTournamentTime.vue";
import IconTournamentVenue from "~src/components/icons/IconTournamentVenue.vue";


const __default__ = {};

interface IProps {
  match: any;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Information',
  props: {
    match: {}
  },
  setup(__props: any) {

const props = __props;

const showMatchTime = computed(() => (timestamp: string | number) => {
  const timeValue =
    typeof timestamp === "string" ? parseInt(timestamp) : timestamp;

  const date = new Date(timeValue * 1000);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Tháng tính từ 0
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
});

const convertCourtType = computed(() => (group_id: number) => {
  const groupType: { [key: number]: string } = StatsEnum.groupType;

  return groupType[group_id] || "-";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationIcon),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: 
            _ctx.match?.unique_tournament?.logo ||
            _ctx.getImgUrlBySport(
              'competition',
              _ctx.match?.unique_tournament?.id ?? _ctx.match.unique_tournament_id
            )
          ,
            class: "as-icon",
            width: "37",
            height: "37"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-name" }, "Giải đấu", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.match?.unique_tournament?.name ?? "-"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(IconTournamentTime)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-name" }, "Thời gian thi đấu", -1)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(showMatchTime.value(_ctx.match.match_time)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(IconTournamentVenue)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-name" }, "Địa điểm", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.match?.country?.name ?? "-"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(IconTournamentCourt)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-name" }, "Sân thi đấu", -1)),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.match?.venue?.name ?? "-"), 1)
        ])
      ])
    ])
  ], 64))
}
}

})